export default function About() {
    return (
        <div>
            <h1>About</h1>
            <p>
                This is the front-end running on CloudFront + S3 with OAC, secured and deployed via CDK.
            </p>
        </div>
    );
}
